class ProductBanner {
  constructor() {
    this.modal = document.getElementById('product-viewer-modal');
    this.modalBody = this.modal?.querySelector('.product-viewer-modal__body');

    if (!this.modal || !this.modalBody) return;

    this.iframeUrl = this.modal.dataset.iframeUrl;
    this.buyUrl = this.modal.dataset.buyUrl;
    this._onMessage = this._onMessage.bind(this);
    this._onScroll = this._onScroll.bind(this);
    this.bindEvents();
  }

  bindEvents() {
    const banner = document.querySelector('.banner-clickable');
    if (banner) {
      banner.addEventListener('click', () => this.openModal());
    }

    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });

    const closeBtn = this.modal.querySelector('.product-viewer-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.closeModal());
    }
  }

  _onMessage(e) {
    if (!e.data || typeof e.data !== 'object') return;

    if (e.data.type === 'pv-resize') {
      const iframe = this.modalBody.querySelector('.product-viewer-modal__iframe');
      if (iframe) {
        iframe.style.height = e.data.height + 'px';
      }
      requestAnimationFrame(() => this._onScroll());
    }

    if (e.data.type === 'pv-navigate' && e.data.url) {
      window.location.href = e.data.url;
    }
  }

  _onScroll() {
    const atBottom = this.modalBody.scrollTop + this.modalBody.clientHeight >= this.modalBody.scrollHeight - 4;
    this.modal.classList.toggle('is-at-bottom', atBottom);
  }

  openModal() {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    const iframe = document.createElement('iframe');
    const separator = this.iframeUrl.includes('?') ? '&' : '?';
    const src = this.buyUrl
      ? this.iframeUrl + separator + 'buyUrl=' + encodeURIComponent(this.buyUrl)
      : this.iframeUrl;
    iframe.src = src;
    iframe.className = 'product-viewer-modal__iframe';
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('scrolling', 'no');
    iframe.addEventListener('load', () => {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!doc) return;
        const style = doc.createElement('style');
        // Hide the headline and legal-disclaimer sections; keep only the product viewer.
        style.textContent = '.channel-html .section { display: none !important; }';
        doc.head.appendChild(style);
      } catch (_) {}
    });
    this.modalBody.appendChild(iframe);

    window.addEventListener('message', this._onMessage);
    this.modalBody.addEventListener('scroll', this._onScroll);

    this.modal.classList.remove('is-visible');
    this.modal.classList.remove('is-at-bottom');
    if (this.modal.open) this.modal.close();
    this.modal.offsetHeight;

    this.modal.showModal();
    requestAnimationFrame(() => {
      this.modal.classList.add('is-visible');
      this._onScroll();
    });
  }

  closeModal() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    this.modal.classList.remove('is-visible');
    this.modal.classList.remove('is-at-bottom');
    window.removeEventListener('message', this._onMessage);
    this.modalBody.removeEventListener('scroll', this._onScroll);
    setTimeout(() => {
      if (this.modal.open) this.modal.close();
      this.modalBody.innerHTML = '';
    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductBanner();
});
